import { render, staticRenderFns } from "./EditAttendanceSetting.vue?vue&type=template&id=5bea6f3e&"
import script from "./EditAttendanceSetting.vue?vue&type=script&lang=js&"
export * from "./EditAttendanceSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports